import {
	defAction
}from "../../../../helpers/defaultAction"
import {
	reOrgConstants
}from "./constants"
import api from './api'

export const reOrgActions = {
	getMinOrgByNameOrUNP,
	getPaged,
	create,
	update,
	remove,
	clear,
	getReOrgInfo,
	updateReOrgInfo

}
function getReOrgInfo(values){
	const dispatchObj = {
		constants : reOrgConstants.GetReOrgInfo,
		service   : {
			func   : api.getReOrgInfo,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getMinOrgByNameOrUNP(values){
	const dispatchObj = {
		constants : reOrgConstants.GetMinOrgByNameOrUNP,
		service   : {
			func   : api.getMinOrgByNameOrUNP,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getPaged(values){
	const dispatchObj = {
		constants : reOrgConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reOrgConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reOrgConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function updateReOrgInfo(values){
	const dispatchObj = {
		constants : reOrgConstants.UpdateReOrgInfo,
		service   : {
			func   : api.updateReOrgInfo,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reOrgConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reOrgConstants.CLEAR
	})
}